import UXCoreModal from './UXCoreModal';

export default UXCoreModal;
